import { createApp } from 'vue'
import CustomForm from './CustomForm'
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component__custom-form";

export default function () {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {

        DOM.forEach(async (CustomFormDOM) => {
            const formId = CustomFormDOM.getAttribute('data-id')
            const formGuid = CustomFormDOM.getAttribute('data-form-guid')
            const recaptchaSiteKey = CustomFormDOM.getAttribute('data-recaptcha-site-key')
            const apiPath = CustomFormDOM.getAttribute('data-api-path')
            const antiForgeryToken = CustomFormDOM.getAttribute('data-anti-forgery-token')
            const formSchemaString = CustomFormDOM.getAttribute('data-form-schema')
            let formSchemaData;

            if (formSchemaString) {
                const decodedFormSchema = decodeURIComponent(formSchemaString);
                formSchemaData = JSON.parse(decodedFormSchema);
            }
            else {
                const response = await fetch(new Request(`/_forms/v1/forms/${formId}`))
                formSchemaData = await response.json();
            }

            const formElements = formSchemaData.formElements;
            const component = createApp(CustomForm, {
                formElements,
                showSummarizedData: formSchemaData.properties.showSummarizedData,
                summaryConfirmationButtonLabel: formSchemaData.properties.summaryConfirmationButtonLabel,
                summaryCancellationButtonLabel: formSchemaData.properties.summaryCancellationButtonLabel,
                confirmationMessage: formSchemaData.properties.confirmationMessage,
                submitSuccessMessage: formSchemaData.properties.submitSuccessMessage,
                submitErrorMessage: formSchemaData.properties.submitErrorMessage,
                resetAfterSubmission: formSchemaData.properties.resetAfterSubmission,
                formTitle: formSchemaData.properties.title,
                formId,
                formGuid,
                apiPath,
                antiForgeryToken
            })
            component.use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(CustomFormDOM)
        })
    }
}

